export function LiveBadge() {
  return (
    <span className="rounded-full border border-teal-200 bg-teal-50 px-2.5 py-0.5 text-xs font-semibold text-teal-800">
      Live from Stripe
    </span>
  );
}
